// Constants and helpers for the admin Product Support screen (ENG-7614),
// backed by the transaction-service support-debug endpoints.

// Only SUPER_ADMIN may view the screen (mirrors the API's authorization —
// the endpoints return 403 for every other role).
export const SUPPORT_DEBUG_ROLES = ["SUPER_ADMIN"] as const;

export const canViewSupportDebug = (role?: string | null): boolean =>
  !!role && SUPPORT_DEBUG_ROLES.includes(role as (typeof SUPPORT_DEBUG_ROLES)[number]);

// Registry of available tools. Adding a new tool = one entry here + one panel
// component wired into SupportDebug.tsx.
export type SupportDebugToolId = "upcoming-bills" | "safe-to-spend" | "cashflow-shortfall";

export interface SupportDebugTool {
  id: SupportDebugToolId;
  label: string;
  description: string;
}

export const SUPPORT_DEBUG_TOOLS: SupportDebugTool[] = [
  {
    id: "upcoming-bills",
    label: "Upcoming Bills",
    description: "Recurring bills predicted over the next 30 days",
  },
  {
    id: "safe-to-spend",
    label: "Safe to Spend",
    description: "How the Safe to Spend number is calculated",
  },
  {
    id: "cashflow-shortfall",
    label: "Cashflow Shortfall",
    description:
      "Spending Health widget state and the pay-period cashflow projection behind it",
  },
];

export const isSupportDebugToolId = (
  value: string | null | undefined
): value is SupportDebugToolId =>
  !!value && SUPPORT_DEBUG_TOOLS.some((tool) => tool.id === value);
